
export default function ServicesGrid() {
  const services = [
    {
      icon: 'ri-hand-heart-line',
      title: 'Manual Testing',
      description: 'Comprehensive manual testing to identify bugs and ensure optimal user experience.',
      features: [
        'Functional Testing',
        'Usability Testing',
        'Exploratory Testing',
        'Cross-browser Testing'
      ]
    },
    {
      icon: 'ri-robot-line',
      title: 'Automated Testing',
      description: 'Efficient automated testing solutions to accelerate development and ensure quality.',
      features: [
        'Test Automation Framework',
        'Regression Testing',
        'Continuous Integration',
        'Test Script Development'
      ]
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Mobile Testing',
      description: 'Cross-platform mobile testing for perfect functionality on all devices.',
      features: [
        'iOS Testing',
        'Android Testing',
        'Device Compatibility',
        'Mobile Performance'
      ]
    },
    {
      icon: 'ri-global-line',
      title: 'Cross-browser Testing',
      description: 'Ensure your application works flawlessly across all browsers and platforms.',
      features: [
        'Navigation, buttons, menus, modals, and forms',
        'Checkout flows and interactive components',
        'Real device testing via BrowserStack, LambdaTest, or physical lab'
      ]
    },
    {
      icon: 'ri-refresh-line',
      title: 'Ongoing QA',
      description: 'Continuous quality assurance support to maintain excellence throughout your product lifecycle.',
      features: [
        'Regular Quality Audits',
        'Performance Monitoring',
        'Bug Tracking & Resolution',
        'Quality Metrics Reporting'
      ]
    },
    {
      icon: 'ri-team-line',
      title: 'Tech Partner',
      description: 'Complete technology partnership with dedicated QA team integration and strategic support.',
      features: [
        'Dedicated QA Team',
        'Strategic Planning',
        'Technology Consulting',
        'Long-term Partnership'
      ]
    }
  ];

  return (
    <section id="services" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-[#182114] mb-6" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
            What We <span className="text-[#D96B33]">Offer</span>
          </h2>
          <div className="w-24 h-1 bg-[#D96B33] mx-auto mb-8"></div>
          <p className="text-xl text-[#2E3F25] max-w-3xl mx-auto" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
            Comprehensive quality assurance and testing solutions to ensure your software works flawlessly
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-[#EBEBE0] p-8 rounded-3xl hover:bg-white hover:shadow-2xl transition-all duration-500 cursor-pointer hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#D96B33] to-[#B85A2B] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-[#182114] mb-4" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
                {service.title}
              </h3>
              
              <p className="text-[#2E3F25] mb-6 leading-relaxed" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
                {service.description}
              </p>

              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center gap-3 text-[#2E3F25]" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
                    <i className="ri-check-line text-[#D96B33] text-lg"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}